import { useState } from "react";
import { PageHeader } from "../../page-header";
import { usePagamentoLote } from "../../../hooks/usePagamentoLote";
import { formatValueToMonetary, formatCnpjCpf } from "../../../utils/formatter";
import { toast } from "react-toastify";
import { TbSearch, TbUserPlus } from "react-icons/tb";
import { banco_codigo as bancoCodigo } from "../../../assets/banco_codigo";
import { SearchableSelect } from "../novo-lote/SearchableSelect";
import "../PagamentoLote.css";
import "./PagamentoLoteFavorecidos.css";

const EMPTY_FORM = {
  name: "",
  document: "",
  preferredType: "PIX",
  pixKey: "",
  bank: "",
  agency: "",
  account: "",
  accountDigit: "",
  accountType: "0",
};

function typeIcon(type) {
  const icons = { Boleto: "▥", PIX: "❖", Tributo: "▣", TED: "↔" };
  return icons[type] || "▣";
}

export default function PagamentoLoteFavorecidos() {
  const { payees, addPayee, payments } = usePagamentoLote();
  const [search, setSearch] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(EMPTY_FORM);

  function handleChange(e) {
    let { name, value } = e.target;
    if (name === "document") value = formatCnpjCpf(value);
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!form.name || !form.document) {
      toast.error("Nome e CPF/CNPJ são obrigatórios.");
      return;
    }
    addPayee(form);
    toast.success("Favorecido cadastrado com sucesso!");
    setForm(EMPTY_FORM);
    setShowForm(false);
  }

  const filtered = payees.filter(
    (p) =>
      !search ||
      p.name.toLowerCase().includes(search.toLowerCase()) ||
      p.document.toLowerCase().includes(search.toLowerCase())
  );

  // Last payment amount per payee (from payments state)
  function getLastAmount(payeeName) {
    const found = [...payments]
      .filter((p) => p.payee === payeeName)
      .sort((a, b) => b.id - a.id)[0];
    return found ? formatValueToMonetary(found.amount) : formatValueToMonetary(0);
  }

  return (
    <div className="paylote-page">
      <div className="paylote-inner col-md-10 m-auto mt-4">
        <div className="mb-3">
          <PageHeader
            title="Favorecidos"
            pages={[
              { name: "Pagamento em Lote", link: "/pagamento-lote/dashboard" },
              { name: "Favorecidos" },
            ]}
          />
        </div>

        {/* New payee form */}
        {showForm && (
          <section className="paylote-section-card">
            <div className="paylote-section-header">
              <div>
                <h2>Cadastrar novo favorecido</h2>
                <p className="paylote-subtitle">Preencha os dados do fornecedor ou beneficiário.</p>
              </div>
              <button className="paylote-btn-secondary" type="button" onClick={() => setShowForm(false)}>
                Cancelar
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="paylote-form-grid">
                <div className="paylote-form-field">
                  <label>Nome / razão social *</label>
                  <input name="name" value={form.name} onChange={handleChange} placeholder="Nome do favorecido" />
                </div>
                <div className="paylote-form-field">
                  <label>CPF / CNPJ *</label>
                  <input name="document" value={form.document} onChange={handleChange} placeholder="00.000.000/0001-00" />
                </div>
                <div className="paylote-form-field">
                  <label>Tipo de pagamento preferido</label>
                  <select name="preferredType" value={form.preferredType} onChange={handleChange}>
                    <option value="PIX">PIX</option>
                    <option value="TED">TED</option>
                  </select>
                </div>
              </div>

              {form.preferredType === "PIX" && (
                <div className="paylote-form-grid two">
                  <div className="paylote-form-field">
                    <label>Chave PIX</label>
                    <input name="pixKey" value={form.pixKey} onChange={handleChange} placeholder="CPF, CNPJ, e-mail, telefone ou chave aleatória" />
                  </div>
                </div>
              )}

              {form.preferredType === "TED" && (
                <div className="paylote-form-grid">
                  <div className="paylote-form-field paylote-ted-bank">
                    <label>Banco</label>
                    <SearchableSelect
                      value={form.bank}
                      onChange={(val) => setForm((prev) => ({ ...prev, bank: val }))}
                      options={bancoCodigo.map((b) => ({ value: b.value, label: b.label }))}
                      placeholder="— Selecione o banco —"
                    />
                  </div>
                  <div className="paylote-form-field">
                    <label>Agência</label>
                    <input name="agency" value={form.agency} onChange={handleChange} placeholder="0000" maxLength={6} />
                  </div>
                  <div className="paylote-form-field">
                    <label>Conta</label>
                    <input name="account" value={form.account} onChange={handleChange} placeholder="00000000" maxLength={20} />
                  </div>
                  <div className="paylote-form-field" style={{ maxWidth: "100px" }}>
                    <label>Dígito</label>
                    <input name="accountDigit" value={form.accountDigit} onChange={handleChange} placeholder="0" maxLength={1} />
                  </div>
                  <div className="paylote-form-field">
                    <label>Tipo de conta</label>
                    <select name="accountType" value={form.accountType} onChange={handleChange}>
                      <option value="0">Conta Corrente</option>
                      <option value="1">Conta Poupança</option>
                    </select>
                  </div>
                </div>
              )}

              <button className="paylote-btn-success" type="submit">
                Salvar favorecido
              </button>
            </form>
          </section>
        )}

        {/* Table */}
        <section className="paylote-table-card">
          <div className="paylote-table-toolbar">
            <div className="paylote-search-area">
              <div className="paylote-search-box">
                <TbSearch size={15} />
                <input
                  type="text"
                  placeholder="Buscar por nome ou CPF/CNPJ..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>

            {!showForm && (
              <div className="paylote-fav-btn-wrap">
                <button className="paylote-btn-primary" onClick={() => setShowForm(true)}>
                  <TbUserPlus size={15} /> Novo favorecido
                </button>
              </div>
            )}
          </div>

          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Documento</th>
                <th>Tipo favorito</th>
                <th>Detalhe</th>
                <th>Último pagamento</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={5}>
                  <div className="paylote-empty-state">
                    <p>Nenhum favorecido encontrado.</p>
                  </div>
                </td></tr>
              ) : filtered.map((payee) => (
                <tr key={payee.id}>
                  <td>
                    <div className="paylote-payee-name">{payee.name}</div>
                  </td>
                  <td className="paylote-fav-doc-cell">{formatCnpjCpf(payee.document)}</td>
                  <td>
                    <span className="paylote-type-badge">
                      {typeIcon(payee.preferredType)} {payee.preferredType}
                    </span>
                  </td>
                  <td className="paylote-fav-detail-cell">
                    {payee.preferredType === "PIX" && payee.pixKey ? `Chave: ${payee.pixKey}` : ""}
                    {payee.preferredType === "TED" && payee.bank
                      ? `${payee.bank} | Ag ${payee.agency} | CC ${payee.account}${payee.accountDigit ? `-${payee.accountDigit}` : ""} | ${payee.accountType === "1" ? "Poupança" : "Corrente"}`
                      : ""}
                  </td>
                  <td><strong>{getLastAmount(payee.name)}</strong></td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </div>
    </div>
  );
}
